import React from 'react'

const StartEncounterIcon = () => {
    return (
        <svg id="start_black_24dp" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <rect id="Rectangle_37083" data-name="Rectangle 37083" width="24" height="24" fill="none" />
            <path id="Path_206782" data-name="Path 206782" d="M14.59,7.41,18.17,11H6v2H18.17l-3.59,3.59L16,18l6-6L16,6ZM2,6V18H4V6Z" fill="#fff" />
        </svg>
    )
}

export default StartEncounterIcon
